// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loader[data-v-bd697df8]{width:48px;height:48px;border:5px solid;border-color:#6cc #6cc transparent;border-radius:50%;display:inline-block;box-sizing:border-box;-webkit-animation:rotation-data-v-bd697df8 1s linear infinite;animation:rotation-data-v-bd697df8 1s linear infinite}@-webkit-keyframes rotation-data-v-bd697df8{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@keyframes rotation-data-v-bd697df8{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);
// Exports
module.exports = exports;
